<template>
	<div class="budget-bar">
		<div
			class="filled"
			:class="{ overflow: overflow }"
			:style="{ width: fillWidth }"
		></div>
		<div class="remainder"></div>
	</div>
</template>
<script>
export default {
	props: {
		value: {
			type: Number,
			default: 0
		},
		maxValue: {
			type: Number,
			default: 0
		},
		overflow: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		fillWidth() {
			if (this.overflow) {
				return '100%';
			}
			return (this.value / this.maxValue) * 100 + '%';
		}
	}
};
</script>
<style lang="scss" scoped>
.budget-bar {
	width: 100%;
	display: flex;
	height: 4px;
	border-radius: 2px;

	.filled {
		background-color: $budget-bar-color;

		&.overflow {
			background-color: $budget-bar-overflow-color;
		}
	}

	.remainder {
		flex-grow: 1;
		background-color: $budget-bar-remainder-color;
	}
}
</style>
